import { JobStatus } from 'cli/enums';
import { cliJobService } from 'cli/services';
import { ICliJob, ICliJobQuery } from 'cli/types';
import { NotificationPosition } from 'core/enums';
import { useQueryChecker } from 'core/hooks';
import { useQueriesChecker } from 'core/hooks/useQueriesChecker';
import { GetOneResponse, INotificationContent } from 'core/types';

interface ICliJobCheckerProps {
  criteria: { job: number };
  enabled: boolean;
  onSuccess: (data?: GetOneResponse<ICliJob>) => void;
  options?: {
    success?: INotificationContent;
    loading?: INotificationContent;
    error?: INotificationContent;
    notificationPosition?: NotificationPosition;
  };
  onError?: (data?: GetOneResponse<ICliJob>) => void;
}

interface ICliJobsCheckerProps {
  queries: ICliJobQuery[];
  onSuccess: (data?: GetOneResponse<ICliJob>) => void;
  onError?: (data?: GetOneResponse<ICliJob>) => void;
}

export const useCliJobChecker = ({
  criteria,
  enabled = false,
  onSuccess,
  options,
  onError,
}: ICliJobCheckerProps) => {
  useQueryChecker<GetOneResponse<ICliJob>>({
    fetchData: cliJobService.getDetails,
    queryKey: 'cliJob',
    requestPayload: criteria,
    enabled,
    isFetchDataFinished: (data: GetOneResponse<ICliJob>) =>
      JobStatus.FINISHED === data?.record?.status,
    onSuccess,
    options,
    isFetchDataFailed: (data: { record: ICliJob }) =>
      JobStatus.FAILED === data?.record?.status || JobStatus.CANCELED === data?.record?.status,
    getFetchDataFailedErrorMessage: (data: { record: ICliJob }) => data?.record?.statusDescription,
    onError,
  });
};

export const useCliJobsChecker = ({ queries, onSuccess, onError }: ICliJobsCheckerProps) => {
  useQueriesChecker<GetOneResponse<ICliJob>>({
    queries,
    fetchData: cliJobService.getDetails,
    isFetchDataFinished: (data) => 'finished' === data?.record?.status,
    onSuccess,
    isFetchDataFailed: (data: { record: ICliJob }) =>
      JobStatus.FAILED === data?.record?.status || JobStatus.CANCELED === data?.record?.status,
    getFetchDataFailedErrorMessage: (data: { record: ICliJob }) => data?.record?.statusDescription,
    onError,
  });
};
